import type { DesignCanvas, Frame, Layer } from '@pfe/design-renderer'

export type SnapLine = { axis: 'x' | 'y'; mm: number }

/**
 * Kandidaten: Trim-Kanten, Trim-Mitte, Sicherheitsbereich, Beschnitt-Kanten sowie Kanten/
 * Mitten anderer Layer. Schwelle in mm (aus Pixel-Schwelle / pxPerMm).
 */
export function snapFrame(frame: Frame, canvas: DesignCanvas, others: Layer[], thresholdMm: number, enabled = true): { frame: Frame; lines: SnapLine[] } {
  if (!enabled || frame.rotationDeg) return { frame, lines: [] }
  const xs: number[] = [0, canvas.widthMm / 2, canvas.widthMm, -canvas.bleedMm, canvas.widthMm + canvas.bleedMm]
  const ys: number[] = [0, canvas.heightMm / 2, canvas.heightMm, -canvas.bleedMm, canvas.heightMm + canvas.bleedMm]
  if (canvas.safeMarginMm > 0) {
    xs.push(canvas.safeMarginMm, canvas.widthMm - canvas.safeMarginMm)
    ys.push(canvas.safeMarginMm, canvas.heightMm - canvas.safeMarginMm)
  }
  for (const o of others) {
    if (!o.visible) continue
    xs.push(o.frame.xMm, o.frame.xMm + o.frame.wMm / 2, o.frame.xMm + o.frame.wMm)
    ys.push(o.frame.yMm, o.frame.yMm + o.frame.hMm / 2, o.frame.yMm + o.frame.hMm)
  }
  const lines: SnapLine[] = []
  let x = frame.xMm
  let y = frame.yMm
  const edgesX = [frame.xMm, frame.xMm + frame.wMm / 2, frame.xMm + frame.wMm]
  const edgesY = [frame.yMm, frame.yMm + frame.hMm / 2, frame.yMm + frame.hMm]
  let bestX: { d: number; shift: number; mm: number } | null = null
  for (const e of edgesX) for (const c of xs) {
    const d = Math.abs(e - c)
    if (d <= thresholdMm && (!bestX || d < bestX.d)) bestX = { d, shift: c - e, mm: c }
  }
  let bestY: { d: number; shift: number; mm: number } | null = null
  for (const e of edgesY) for (const c of ys) {
    const d = Math.abs(e - c)
    if (d <= thresholdMm && (!bestY || d < bestY.d)) bestY = { d, shift: c - e, mm: c }
  }
  if (bestX) { x += bestX.shift; lines.push({ axis: 'x', mm: bestX.mm }) }
  if (bestY) { y += bestY.shift; lines.push({ axis: 'y', mm: bestY.mm }) }
  return { frame: { ...frame, xMm: Math.round(x * 100) / 100, yMm: Math.round(y * 100) / 100 }, lines }
}
